import { useCallback, useEffect, useState } from "react";

import { fetchOnboardingStatus } from "@/api/onboarding";
import type { OnboardingStatus } from "@/types/onboarding";

export function useOnboardingProgress() {
  const [status, setStatus] = useState<OnboardingStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const payload = await fetchOnboardingStatus();
      setStatus(payload);
      setError(null);
      return payload;
    } catch (err) {
      const normalized = err instanceof Error ? err : new Error("Unable to load onboarding status.");
      setError(normalized);
      throw normalized;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    status,
    loading,
    error,
    refresh,
  };
}
